module.exports = __webpack_public_path__ + "img/mp-img-12.e00683f1.jpg";